import * as Sentry from "@sentry/remix"
import { StrictMode, startTransition, useEffect } from "react"
import { hydrateRoot } from "react-dom/client"
import { useLocation, useMatches } from "react-router"
import { HydratedRouter } from "react-router/dom"
import { envClient } from "~/utils/.client"

if (envClient("PUBLIC_BASE_URL_HOST") !== "0.0.0.0") {
  Sentry.init({
    dsn: envClient("PUBLIC_SENTRY_DSN"),
    tracesSampleRate: 1,
    environment:
      envClient("PUBLIC_BASE_URL_HOST") === "loadpass.io"
        ? "production"
        : "development",
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
    ],
  })
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  )
})
